module.exports = __webpack_public_path__ + "08c9de4b23065bba04f7bdcddc853fbf.svg";